import React from 'react'
import marked from 'marked'
import './markdown.scss'

export default ({ content = '', highlightWord }) => {
  const transformedContent = highlightWord ? 
    marked(content.replace(new RegExp(`(${highlightWord})`, 'gi'), '<span class="highlight">$1</span>')) :
    marked(content)
  
  return (
    <div dangerouslySetInnerHTML={{ __html: transformedContent }} className="markdown-container"/>
  )
}


// WEBPACK FOOTER //
// ./src/components/Markdown/markdown.js